// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1ZOnI","title":"FrontImage_title__ZUZ8T"};